import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DragLayer as dragLayer } from 'react-dnd';
import uuid from 'uuid/v4';
import DnDItemTypes from './DnDItemTypes';
import DraggedGridRowPreview from './DraggedGridRowPreview';
import DraggedAnswerPreview from './DraggedAnswerPreview';

const layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 100,
  right: '25%',
  top: 20,
  width: '100%',
  height: '100%',
};

function getItemStyles(props) {
  const { initialOffset, currentOffset } = props;
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none',
    };
  }

  const { x, y } = currentOffset;

  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform,
    WebkitTransform: transform,
  };
}

function collect(monitor) {
  return {
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  };
}

class CustomDragLayer extends Component {
  renderItem(type) {
    switch (type) {
      case DnDItemTypes.DnD_ITEM_TYPE_2:
        return (
          <DraggedAnswerPreview
            selectedPreviewItems={this.props.selectedPreviewItems}
            nodeType={DnDItemTypes.DnD_ITEM_TYPE_2}
          />
        );
      case DnDItemTypes.DnD_ITEM_TYPE_3:
        return (
          <DraggedGridRowPreview
            selectedPreviewItems={this.props.selectedPreviewItems}
            nodeType={DnDItemTypes.DnD_ITEM_TYPE_3}
          />
        );
      case DnDItemTypes.DnD_ITEM_TYPE_4:
        return (
          <DraggedAnswerPreview
            selectedPreviewItems={this.props.selectedPreviewItems}
            nodeType={DnDItemTypes.DnD_ITEM_TYPE_4}
          />
        );
      default:
        return (
          <div className="row">
            <div className="large-6 columns dragged-preview-grid">
              {this.props.selectedPreviewItems.map(item => (
                <div key={uuid()} className="dragged-preview-item">
                  {item.title}
                </div>
              ))}
            </div>
          </div>
        );
    }
  }

  render() {
    const { itemType, isDragging } = this.props;

    if (!isDragging) {
      return null;
    }

    return (
      <div style={layerStyles}>
        <div style={getItemStyles(this.props)}>{this.renderItem(itemType)}</div>
      </div>
    );
  }
}

CustomDragLayer.propTypes = {
  itemType: PropTypes.string,
  initialOffset: PropTypes.shape({}),
  currentOffset: PropTypes.shape({}),
  selectedPreviewItems: PropTypes.arrayOf(PropTypes.object),
  isDragging: PropTypes.bool.isRequired,
};

export default dragLayer(collect)(CustomDragLayer);
